// ODDS TRUST RULE (centralized).
// An odd may only be shown to the customer if we know its value AND a source/provider.
// A captured/updated timestamp is shown when available. If the source is unknown,
// the odd is HIDDEN from customer-facing recommendation surfaces (never shown as a
// misleading generic/unattributed value).

export interface OddInput {
  value: number | null | undefined;
  source?: string | null;      // provider / bookmaker name
  updatedAt?: string | null;   // ISO capture/update timestamp
}

export interface PresentedOdd {
  show: boolean;
  value: string;               // formatted, e.g. "1.85"
  source: string | null;
  updatedAt: string | null;
}

// The current SDIP public payload exposes an `odd`/`reference_odd` number but NO
// provider/source field. Per the trust rule we therefore do NOT surface it as an
// authoritative betting odd. When a source field is later supplied by the backend,
// pass it here and the odd renders WITH attribution automatically.
export function presentOdd(input: OddInput): PresentedOdd {
  const { value, source, updatedAt } = input;
  const hasValue = value != null && !isNaN(value as number);
  const hasSource = !!(source && source.trim());
  return {
    show: hasValue && hasSource,
    value: hasValue ? (value as number).toFixed(2) : "—",
    source: hasSource ? source!.trim() : null,
    updatedAt: updatedAt || null,
  };
}
